import { render, staticRenderFns } from "./ThanksPage.vue?vue&type=template&id=4b2c7bfc&scoped=true"
import script from "./ThanksPage.vue?vue&type=script&lang=js"
export * from "./ThanksPage.vue?vue&type=script&lang=js"
import style0 from "./ThanksPage.vue?vue&type=style&index=0&id=4b2c7bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c7bfc",
  null
  
)

export default component.exports